module.exports = __webpack_public_path__ + "img/plan.3519371b.png";